// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__XB55X","left":"StickyBox_left__3QJlR","right":"StickyBox_right__1A_yO"};